app.controller('OrderCustomCustomerDiscountController', ['$rootScope', '$scope', '$bootstrapModal', function ($rootScope, $scope, $bootstrapModal) {

    if (!$scope.getOrder) {
        $scope.getOrder = function () {
            return $rootScope.model.order.current_order;
        }
    }

    $scope.editCustomerDiscounts = function () {


        const order = $scope.getOrder();
        const customerDiscounts = $rootScope.model.account.customer_data.discounts;

        const cartLines = $rootScope.service.order_helper.cart_linesAndSublines(order);
        const relevantDiscountGroupIDs = [];

        order.discounts = $rootScope.site_helper.requireObject(order.discounts);
        const visibleDiscounts = [];


        for (let i = 0; i < cartLines.length; i++) {
            const discountGroupID = cartLines[i]._discount_group;
            if (discountGroupID && relevantDiscountGroupIDs.indexOf(discountGroupID) === -1 && customerDiscounts[discountGroupID]) {
                relevantDiscountGroupIDs.push(discountGroupID);
                const customerDiscount = customerDiscounts[discountGroupID];
                let overrideDiscountValue;
                if (order.discounts[discountGroupID]) {
                    overrideDiscountValue = order.discounts[discountGroupID];
                } else {
                    overrideDiscountValue = customerDiscount.discount;
                }

                visibleDiscounts.push({
                    id: discountGroupID,
                    description: customerDiscount.description,
                    discount: customerDiscount.discount ? customerDiscount.discount : 0,
                    override_discount_value: overrideDiscountValue
                });
            }
        }

        const listModel = new $rootScope.model_constructor.ListModel({page_size: 500})

        $bootstrapModal.open({
            templateUrl: 'OrderCustomModalCustomerDiscount.html',
            controller: 'CommonModalSimpleController',
            //size: 'md',
            resolve: {
                items: {
                    list_model: listModel,
                    visible_discounts: visibleDiscounts,
                    callback: function () {
                        for (let i = 0; i < visibleDiscounts.length; i++) {
                            const item = visibleDiscounts[i]
                            order.discounts[item.id] = item.override_discount_value;
                        }


                        $rootScope.service.order.saveOrder();
                    }
                }
            }
        });
    };
}]);